import { Component, HostListener, OnInit } from '@angular/core';
import { Renderer2, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { SnackBarHandler } from 'src/app/other/open-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../app.service';
import { ShopService } from './shop.service';
import { environment } from 'src/environments/environment';
import { BuildConfig } from 'src/app/handler/build-config';
import { cloneDeep } from 'lodash';
import { Util } from 'src/app/util/util';
import * as moment from 'moment';
import { CheckAuthToken } from 'src/app/handler/auth-check';
import { StaticMemory } from 'src/app/handler/static_memory';
import { PopupDialogComponent } from 'src/app/element-widgets/popup-dialog/popup-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LocationSetDialogComponent } from 'src/app/element-widgets/location-set-dialog/location-set-dialog.component';
import { VariantSelectionDialogComponent } from 'src/app/element-widgets/variant-selection-dialog/variant-selection-dialog.component';
import { BottomSheetDialogComponent } from 'src/app/element-widgets/bottom-sheet-dialog/bottom-sheet-dialog.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ApiUtilService } from 'src/app/handler/api-util-service';
export interface PhotosApi {
  title?: string;
  description?: string;
  url?: string;
  link?: string;
}
@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss'],
  providers: [ShopService],
})
export class ShopComponent implements OnInit, AfterViewInit {
  data: Array<any> = [];
  productObj: any = {};
  wishlistObj: any = {};
  loading: boolean = false;
  logedIn: boolean = false;
  localStorageProduct: Array<any> = [];
  localStorageWishlist: Array<any> = [];
  categoryArray: Array<any> = [];
  chipsArray: Array<any> = [];
  subCategoryArray: Array<any> = [];
  cashBackOfferArray: Array<any> = [];
  errorMessage: string = '';

  priceRange: string = '';
  isMenuOpen: boolean = false;
  subCategoryId: string = null;
  parentCategoryId: string = null;
  searchInput: string = null;
  firstLoaded: boolean = true;
  currentOpenCategory: any = null;
  screenWidth: number = 0;
  pageSizeList: Array<number> = [12, 24, 48];
  limit: number = 10;
  pLimit: number = 12;
  pSkip: number = 0;
  checkedPriceRange = null;

  catPriceArray: Array<any> = [
    { type: 1, name: 'Under ₹ 1000', value: '0-1000' },
    { type: 1, name: '₹ 1000 - ₹ 5000', value: '1000-5000' },
    { type: 1, name: '₹ 5000 - ₹ 10000', value: '5000-10000' },
    { type: 1, name: '₹ 10000 - ₹ 20000', value: '10000-20000' },
    { type: 1, name: 'Over ₹ 20000', value: '20000-100000' },
  ];

  @ViewChild('toggleButton') toggleButton!: ElementRef;
  @ViewChild('menu') menu!: ElementRef;
  @ViewChild('categoryMenu') categoryMenu!: ElementRef;

  constructor(
    public dialog: MatDialog,
    private snackbar: SnackBarHandler,
    private service: ShopService,
    private activatedroute: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private renderer: Renderer2,
    private _bottomSheet: MatBottomSheet,
    private apiUtilService: ApiUtilService,
  ) {
    this.logedIn = CheckAuthToken.loggedIn;
    this.localStorageProduct = JSON.parse(localStorage.getItem(BuildConfig.productArray));
    this.localStorageWishlist = JSON.parse(localStorage.getItem(BuildConfig.wishlistArray));
  }

  ngOnInit(): void {
    this.onWindowResize();
    sessionStorage.setItem(BuildConfig.xRoute, window.location.href);
    this.getParentCategories();
    if (CheckAuthToken.loggedIn) {
      this.getCashBackOffers();
    }
  }

  ngAfterViewInit(): void {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (e.target !== this.toggleButton?.nativeElement && e.target !== this.menu?.nativeElement) {
        this.isMenuOpen = false;
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.screenWidth = window.innerWidth;
  }

  toggleSubCategories(category: any): void {
    this.parentCategoryId = category._id;
    if (this.currentOpenCategory === category) {
      this.currentOpenCategory = null;
    } else {
      this.currentOpenCategory = category;
    }
  }

  isCategoryOpen(category: any): boolean {
    return this.currentOpenCategory === category;
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  onNavBarClick(subCategory: any): void {
    this.subCategoryId = subCategory._id;
    let updatedUrl = Util.replaceURLParameter(this.router.url, 'catId', subCategory._id);
    Util.changeURLWithoutReloadWithRouter(this.router, updatedUrl);
  }

  onSideBarItemClick(pCategory: any, subCategory: any): void {
    this.subCategoryArray = pCategory.subCategoriesInfo;
    this.parentCategoryId = pCategory._id;
    this.subCategoryId = subCategory._id;
    let updatedUrl = Util.replaceURLParameter(this.router.url, 'catId', subCategory._id);
    updatedUrl = Util.replaceURLParameter(updatedUrl, 'pId', this.parentCategoryId);
    Util.changeURLWithoutReloadWithRouter(this.router, updatedUrl);
  }

  // onPriceMenuItemClick(event: any): void {
  //   if (event.type === 0) {
  //     if (this.chipsArray && this.chipsArray.length) {
  //       for (let idx of this.chipsArray) {
  //         if (idx.type === 0) {
  //           this.chipsArray.splice(this.chipsArray.indexOf(idx), 1);
  //           break;
  //         }
  //       }
  //     }
  //     this.chipsArray.push({ type: event.type, name: event.categoryName, value: event._id });
  //     Util.changeURLWithoutReloadWithRouter(this.router, Util.replaceURLParameter(this.router.url, 'catId', event._id));
  //   } else if (event.type === 1) {
  //     if (this.chipsArray && this.chipsArray.length) {
  //       for (let idx of this.chipsArray) {
  //         if (idx.type == 1) {
  //           this.chipsArray.splice(this.chipsArray.indexOf(idx), 1);
  //         }
  //       }
  //     }
  //     this.chipsArray.push({ type: event.type, name: event.name, value: event.value });
  //     Util.changeURLWithoutReloadWithRouter(this.router, Util.replaceURLParameter(this.router.url, 'priceRange', event.value));
  //   }
  // }

  setActiveCategory(subCatId: string): void {
    this.subCategoryId = subCatId;
  }

  onClearPriceFilter(): void {
    Util.changeURLWithoutReloadWithRouter(
      this.router,
      Util.replaceURLParameter(this.router.url, 'catId', ''),
    );
    Util.changeURLWithoutReloadWithRouter(
      this.router,
      Util.replaceURLParameter(this.router.url, 'priceRange', ''),
    );
    this.checkedPriceRange = null;
  }

  onChangePrice(event: any): void {
    this.chipsArray.push({ type: event.type, name: event.name, value: event.value });
    Util.changeURLWithoutReloadWithRouter(
      this.router,
      Util.replaceURLParameter(this.router.url, 'priceRange', event.value),
    );
  }

  getCashBackOffers(): void {
    const urlParams: any = {
      type: 3,
      channel: 'NECOM',
      warehouseId: StaticMemory.serAreaObject?.warehouseId,
    };
    this.service.getOffers(urlParams).subscribe((success) => {
      try {
        if (success.status && success.result && success.result.length) {
          this.cashBackOfferArray = success.result;
        }
      } catch (error: any) {}
    });
  }

  getSmallestInvoiceOffer(gTotal: any) {
    const currentDate = parseInt(moment(Date.now()).format('YYYYMMDD'));
    const idx = this.cashBackOfferArray
      .filter(
        (resp: any) => resp.validFromXDate <= currentDate && currentDate <= resp.validTillXDate,
      )
      .sort((a: any, b: any) => a.invoiceValue - b.invoiceValue);

    const { currentOffer } = StaticMemory.onCashBackOfferCalculation(idx, gTotal);
    return currentOffer;
  }

  getParentCategories(): void {
    this.loading = true;
    this.service.getParentCategories().subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          this.categoryArray = success.result;
          this.activatedroute.queryParams.subscribe((paramsOrg) => {
            this.chipsArray = [];
            this.searchInput = paramsOrg.search || '';
            this.priceRange = paramsOrg['priceRange'];
            this.subCategoryId = paramsOrg['catId'];
            this.parentCategoryId = paramsOrg['pId'];

            if (this.parentCategoryId) {
              this.subCategoryArray = success.result.find(
                (item: any) => item._id === this.parentCategoryId,
              ).subCategoriesInfo;
            }
            const selectedPriceRange = this.catPriceArray.find(
              (price) => price.value === this.priceRange,
            );
            if (selectedPriceRange) {
              this.chipsArray.push({
                type: 1,
                name: selectedPriceRange.name,
                value: selectedPriceRange.value,
                checked: true,
              });
              this.checkedPriceRange = selectedPriceRange.value;
            }
            //On click shop if child category Id is not present then it will take the timestamp
            if (!paramsOrg.catId && !paramsOrg.pId) {
              if (!paramsOrg.search || !paramsOrg.search.length) {
                const subCatId: string = this.categoryArray[0].subCategoriesInfo[0]._id;
                let updatedUrl = Util.replaceURLParameter(
                  this.router.url,
                  'catId',
                  subCatId ? subCatId : encodeURIComponent(new Date().getTime().toString()),
                );
                updatedUrl = Util.replaceURLParameter(updatedUrl, 'pId', this.categoryArray[0]._id);
                Util.changeURLWithoutReloadWithRouter(this.router, updatedUrl);
              } else {
                this.getProducts();
              }
            }
            if (this.firstLoaded) {
              const parentCategory = this.categoryArray.find(
                (item) => item._id === this.parentCategoryId,
              );
              if (parentCategory) {
                this.firstLoaded = false;
                this.toggleSubCategories(parentCategory);
              }
            }
            if (paramsOrg.catId && Object.keys(paramsOrg).length) {
              this.getProducts();
            }
          });
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      },
    );
  }

  getProducts(): void {
    this.loading = true;
    this.data = [];
    this.errorMessage = '';
    const urlParams: any = {
      limit: this.pLimit,
      skip: this.pSkip * this.pLimit,
      priceLower: null,
      priceUpper: null,
      searchWith: this.searchInput,
      categoryId: this.subCategoryId,
      channels: JSON.stringify(['NECOM']),
      serviceAreaId: StaticMemory.serAreaObject?._id,
      warehouseId: StaticMemory.serAreaObject?.warehouseId,
    };
    if (this.chipsArray && this.chipsArray.length) {
      for (let i = 0; i < this.chipsArray.length; i++) {
        if (this.chipsArray[i].type === 1) {
          const splitPrice = this.chipsArray[i].value.split('-');
          urlParams.priceLower = splitPrice[0];
          urlParams.priceUpper = splitPrice[1];
        }
      }
    }
    this.service.getProducts(urlParams).subscribe(
      (success) => {
        if (success.status && success.result && success.result.length) {
          const value = cloneDeep(success.result);
          for (let i = 0; i < value.length; i++) {
            value[i].btnSpinner = false;
            if (value[i].subProducts && value[i].subProducts.length) {
              if (value[i].isLoose) {
                for (let k = 0; k < value[i].subProducts.length; k++) {
                  value[i].subProducts[k].unit = null;
                  value[i].subProducts[k].unitValue = null;
                  if (value[i].subProducts[k].qty && value[i].subProducts[k].qty.length) {
                    const idx = value[i].subProducts[k].qty[0];
                    value[i].subProducts[k].unit = idx.unit;
                    value[i].subProducts[k].unitValue = idx.unitValue;
                    if (
                      value[i].subProducts[k].unit === 'Gm' ||
                      value[i].subProducts[k].unit === 'Kg'
                    ) {
                      value[i].subProducts[k].availableQuantity = Math.round(
                        value[i].subProducts[k].availableQuantity / idx.unitValue,
                      );
                    }
                    if (idx.unit === 'Kg') {
                      value[i].subProducts[k].unitValue = idx.unitValue / 1000;
                    }
                  }
                }
              }
              value[i].subProducts[0].default = true;
              value[i].defaultSubProduct = cloneDeep(value[i].subProducts[0]);
              value[i].defaultSubProduct.viewCartBtn = false;
              if (!StaticMemory.isServiceArea) {
                value[i].defaultSubProduct.selectedQuantity = 0;
                value[i].defaultSubProduct.inWishList = false;
              }
              if (value[i].images && value[i].images.length) {
                if (value[i]?.images[0]?.linkMd && value[i]?.images[0]?.linkMd.length) {
                  value[i].imageLink = value[i]?.images[0]?.linkMd;
                }
              } else {
                value[i].imageLink = environment.placeholder;
                value[i].images = [{ link: environment.placeholder }];
              }
            }
          }
          if (!StaticMemory.isServiceArea && CheckAuthToken.loggedIn) {
            if (this.localStorageProduct && this.localStorageProduct.length) {
              if (this.localStorageProduct && this.localStorageProduct.length) {
                for (let i = 0; i < value.length; i++) {
                  for (let x = 0; x < this.localStorageProduct.length; x++) {
                    if (
                      value[i].defaultSubProduct._id === this.localStorageProduct[x].subproductId
                    ) {
                      value[i].defaultSubProduct.selectedQuantity =
                        this.localStorageProduct[x].selectedQuantity;
                    }
                    for (let k = 0; k < value[i].subProducts.length; k++) {
                      if (
                        value[i].subProducts[k]._id === this.localStorageProduct[x].subproductId
                      ) {
                        value[i].subProducts[k].selectedQuantity =
                          this.localStorageProduct[x].selectedQuantity;
                      }
                    }
                  }
                }
              }
            }
            if (this.localStorageWishlist && this.localStorageWishlist.length) {
              for (let i = 0; i < value.length; i++) {
                for (let x = 0; x < this.localStorageWishlist.length; x++) {
                  if (
                    value[i].defaultSubProduct._id === this.localStorageWishlist[x].subProductId
                  ) {
                    value[i].defaultSubProduct.inWishList = true;
                  }
                  for (let k = 0; k < value[i].subProducts.length; k++) {
                    if (value[i].subProducts[k]._id === this.localStorageWishlist[x].subProductId) {
                      value[i].subProducts[k].inWishList = true;
                    }
                  }
                }
              }
            }
          }
          if (!CheckAuthToken.loggedIn) {
            if (this.localStorageProduct && this.localStorageProduct.length) {
              for (let i = 0; i < value.length; i++) {
                for (let x = 0; x < this.localStorageProduct.length; x++) {
                  if (value[i].defaultSubProduct._id === this.localStorageProduct[x].subproductId) {
                    value[i].defaultSubProduct.selectedQuantity =
                      this.localStorageProduct[x].selectedQuantity;
                  }
                  for (let k = 0; k < value[i].subProducts.length; k++) {
                    if (value[i].subProducts[k]._id === this.localStorageProduct[x].subproductId) {
                      value[i].subProducts[k].selectedQuantity =
                        this.localStorageProduct[x].selectedQuantity;
                    }
                  }
                }
              }
            }
            if (this.localStorageWishlist && this.localStorageWishlist.length) {
              for (let i = 0; i < value.length; i++) {
                for (let x = 0; x < this.localStorageWishlist.length; x++) {
                  if (
                    value[i].defaultSubProduct._id === this.localStorageWishlist[x].subProductId
                  ) {
                    value[i].defaultSubProduct.inWishList = true;
                  }
                  for (let k = 0; k < value[i].subProducts.length; k++) {
                    if (value[i].subProducts[k]._id === this.localStorageWishlist[x].subProductId) {
                      value[i].subProducts[k].inWishList = true;
                    }
                  }
                }
              }
            }
          }
          this.data = cloneDeep(value);
        } else {
          this.errorMessage = success.message.toUpperCase();
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.errorMessage = 'HTTP ERROR IN GET PRODUCTS';
      },
    );
  }

  onAddWishlist(defSubProduct: any, index: number, isWishlist: boolean, product: any): void {
    if (CheckAuthToken.loggedIn) {
      if (StaticMemory.isServiceArea) {
        if (isWishlist) {
          this.wishlistObj = cloneDeep({});
          this.wishlistObj.warehouseId = StaticMemory.serAreaObject?.warehouseId;
          this.wishlistObj.productId = product._id;
          this.wishlistObj.subProductId = defSubProduct._id;
          this.wishlistObj.selectedQuantity = defSubProduct.selectedQuantity;
          this.onSubmitWishList(defSubProduct._id, index, 1, isWishlist);
        } else {
          this.wishlistObj = cloneDeep({});
          this.wishlistObj.subProductId = defSubProduct._id;
          this.wishlistObj.productId = product._id;
          this.wishlistObj.warehouseId = StaticMemory.serAreaObject?.warehouseId;
          this.wishlistObj.selectedQuantity = defSubProduct.selectedQuantity;
          this.onSubmitWishList(defSubProduct._id, index, -1, isWishlist);
        }
      } else {
        this.openAlertDialog();
      }
    }
  }

  onAddCart(defSubProduct: any, index: number, product: any): void {
    if (CheckAuthToken.loggedIn) {
      if (StaticMemory.isServiceArea) {
        this.productObj = cloneDeep({});
        this.productObj.selectedQuantity = 1;
        this.productObj.subProductId = defSubProduct._id;
        this.productObj.totalAmount = defSubProduct.price;
        this.productObj.cashback = 0;
        const currentOffer = this.getSmallestInvoiceOffer(defSubProduct.price);
        if (defSubProduct.cashBack && !currentOffer) {
          if (defSubProduct.discountType === 'CENT') {
            this.productObj.cashback = (defSubProduct.price / 100) * defSubProduct.discount;
            this.productObj.cashback *= this.productObj.selectedQuantity;
            if (defSubProduct.discountUpto) {
              if (this.productObj.cashback >= defSubProduct.discountUpto) {
                this.productObj.cashback = defSubProduct.discountUpto;
              }
            }
          } else {
            this.productObj.cashback = defSubProduct.discount * this.productObj.selectedQuantity;
          }
        }
        this.onSubmitCart(defSubProduct._id, 1, index);
        console.log(this.productObj);
      } else {
        this.openAlertDialog();
      }
    } else {
      let count = 1;
      const value = JSON.parse(localStorage.getItem(BuildConfig.productArray));
      if (value) {
        let countValue = JSON.parse(localStorage.getItem(BuildConfig.cartCount));
        let foundProduct = false;
        for (let i = 0; i < value.length; i++) {
          if (defSubProduct._id === value[i].subproductId) {
            value[i].selectedQuantity += 1;
            value[i].totalAmount = value[i].selectedQuantity * defSubProduct.price;
            foundProduct = true;
            if (countValue === null) {
              localStorage.setItem(BuildConfig.cartCount, JSON.stringify(count));
            } else {
              localStorage.setItem(BuildConfig.cartCount, JSON.stringify((countValue += count)));
            }
          }
        }
        if (!foundProduct) {
          value.push({
            selectedQuantity: 1,
            productName: product.productName,
            subproductId: defSubProduct._id,
            price: defSubProduct.price,
            productId: product._id,
            totalAmount: defSubProduct.price,
            availableQuantity: defSubProduct.availableQuantity,
            quantity: defSubProduct.quantity,
            unit: defSubProduct.unit,
            unitValue: defSubProduct.unitValue,
            cashBack: defSubProduct.cashBack,
            cashBackAmount: 0,
            discount: defSubProduct.discount,
            discountType: defSubProduct.discountType,
            discountUpto: defSubProduct.discountUpto,
            link: product.imageLink,
          });
          if (countValue !== null) {
            localStorage.setItem(BuildConfig.cartCount, JSON.stringify((countValue += count)));
          }
        }
        localStorage.setItem(BuildConfig.productArray, JSON.stringify(value));
        this.data[index].defaultSubProduct.viewCartBtn = true;
        this.data[index].defaultSubProduct.selectedQuantity = 1;
        const subP = this.data[index].subProducts;
        for (let i = 0; i < subP.length; i++) {
          if (defSubProduct._id === subP[i]._id) {
            this.data[index].subProducts[i].viewCartBtn = true;
            this.data[index].defaultSubProduct.selectedQuantity = 1;
          }
        }
      } else {
        const productArray = [];
        productArray.push({
          selectedQuantity: 1,
          productName: product.productName,
          subproductId: defSubProduct._id,
          productId: product._id,
          price: defSubProduct.price,
          totalAmount: defSubProduct.price,
          availableQuantity: defSubProduct.availableQuantity,
          quantity: defSubProduct.quantity,
          unit: defSubProduct.unit,
          unitValue: defSubProduct.unitValue,
          cashBack: defSubProduct.cashBack,
          cashBackAmount: 0,
          discount: defSubProduct.discount,
          discountType: defSubProduct.discountType,
          discountUpto: defSubProduct.discountUpto,
          link: product.imageLink,
        });
        localStorage.setItem(BuildConfig.productArray, JSON.stringify(productArray));
        localStorage.setItem(BuildConfig.cartCount, JSON.stringify(count));
        this.data[index].defaultSubProduct.viewCartBtn = true;
        this.data[index].defaultSubProduct.selectedQuantity = 1;
        const subP = this.data[index].subProducts;
        for (let i = 0; i < subP.length; i++) {
          if (defSubProduct._id === subP[i]._id) {
            this.data[index].subProducts[i].viewCartBtn = true;
            this.data[index].defaultSubProduct.selectedQuantity = 1;
          }
        }
      }
      this.appService.onOfflineCartReload.next();
    }
  }

  onSubmitWishList(id: string, index: number, count: number, isWishlist: boolean): void {
    if (navigator.onLine) {
      if (isWishlist) {
        this.service.postWishlist(this.wishlistObj).subscribe(
          (success) => {
            if (success.status) {
              this.appService.onOnlineWishlistReload.next();
              this.data[index].defaultSubProduct.inWishList = true;
              if (count > 0) {
                const subP = this.data[index].subProducts;
                for (let i = 0; i < subP.length; i++) {
                  if (id === subP[i]._id) {
                    this.data[index].subProducts[i].inWishList = true;
                  }
                }
              }
            } else {
              this.data[index].defaultSubProduct.inWishList = false;
            }
          },
          (error) => {
            this.data[index].defaultSubProduct.inWishList = false;
          },
        );
      } else {
        this.service.deleteWishlistItem(this.wishlistObj).subscribe(
          (success) => {
            if (success.status) {
              this.appService.onOnlineWishlistReload.next();
              this.data[index].defaultSubProduct.inWishList = false;
              if (count < 1) {
                const subP = this.data[index].subProducts;
                for (let i = 0; i < subP.length; i++) {
                  if (id === subP[i]._id) {
                    this.data[index].subProducts[i].inWishList = false;
                  }
                }
              }
            } else {
              this.data[index].defaultSubProduct.inWishList = true;
            }
          },
          (error) => {
            this.data[index].defaultSubProduct.inWishList = true;
          },
        );
      }
    } else {
      this.wishlistObj = cloneDeep({});
      this.snackbar.openDefaultSnackBar('No Internet');
    }
  }

  onSubmitCart(id: string, count: number, index: number): void {
    this.data[index].btnSpinner = true;
    this.productObj.warehouseId = StaticMemory.serAreaObject?.warehouseId;
    this.productObj.serviceAreaId = StaticMemory.serAreaObject?._id;
    this.productObj.channel = environment.defaultChannel;
    if (navigator.onLine) {
      this.service.postProductInCart(this.productObj).subscribe(
        (success) => {
          if (success.status) {
            this.appService.onOnlineCartReload.next();
            this.data[index].defaultSubProduct.selectedQuantity += cloneDeep(count);
            if (count > 0) {
              const subP = this.data[index].subProducts;
              for (let i = 0; i < subP.length; i++) {
                if (id === subP[i]._id) {
                  if (
                    this.data[index].defaultSubProduct.availableQuantity !==
                    this.data[index].defaultSubProduct.selectedQuantity
                  ) {
                    if (this.data[index].defaultSubProduct.selectedQuantity !== 5) {
                      this.data[index].subProducts[i].selectedQuantity++;
                    }
                  }
                }
              }
            } else {
              const subP = this.data[index].subProducts;
              for (let i = 0; i < subP.length; i++) {
                if (id === subP[i]._id) {
                  this.data[index].subProducts[i].selectedQuantity--;
                }
              }
            }
            if (this.data[index].defaultSubProduct.bxgy) {
              this.apiUtilService.postOfferApply(this.data[index].defaultSubProduct);
            }
          }
          this.data[index].btnSpinner = false;
        },
        (error: any) => {
          this.data[index].btnSpinner = false;
        },
      );
    } else {
      this.data[index].btnSpinner = false;
      this.productObj = cloneDeep({});
      this.snackbar.openDefaultSnackBar('No Internet');
    }
  }

  onNextPage(): void {
    this.pSkip++;
    this.getProducts();
  }

  onPreviousPage(): void {
    this.pSkip--;
    this.getProducts();
  }

  onPageSizeChange(): void {
    this.getProducts();
  }

  onPriceFilter(): void {
    this.openPriceFilterBottomSheetDialog();
  }

  openVariantDialog(element: any, index: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = ['dialog-class'];
    dialogConfig.height = 'auto';
    dialogConfig.width = '550px';
    dialogConfig.data = { dialog_data: element };
    const dialogRef = this.dialog.open(VariantSelectionDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.data[index].defaultSubProduct = result;
      }
    });
  }

  openAlertDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.panelClass = ['dialog-class'];
    dialogConfig.height = 'auto';
    dialogConfig.width = '450px';
    dialogConfig.data = { title: 'Your address is not serviceable. Please update your address?' };
    const dialogRef = this.dialog.open(PopupDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (PopupDialogComponent.result) {
        const data = {
          location_message: '',
          type: 1,
        };
        this.openLocationSetDialog(data);
      }
    });
  }

  openLocationSetDialog(data: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = ['dialog-class'];
    dialogConfig.height = 'auto';
    dialogConfig.width = '1000px';
    dialogConfig.data = data;
    const dialogRef = this.dialog.open(LocationSetDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // TODO
      }
    });
  }

  openPriceFilterBottomSheetDialog(): void {
    const _bottomSheetRef = this._bottomSheet.open(BottomSheetDialogComponent);
    _bottomSheetRef.afterDismissed().subscribe((result) => {
      if (result) {
        this.onChangePrice(result);
      }
    });
  }
}
